import QuestionnaireSdk from '@bilibili-business/questionnaire-sdk'
import translate from '@bilibili-business/textformat-sdk'
import source from '@/i18n/text'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { checkIsLogin } from './sub-main'
import { setCommonApp } from '@Utils/setCommonApp'

import '@Assets/css/index.less'
import '@Assets/css/base.css'

import '@Assets/css/cover-element.css'
import 'video.js/dist/video-js.css'
import '@bilibili-business/BiliCharts/dist/style.css'
import '@bilibili-business/bili-design/dist/index.css'
import '@Assets/css/var.scss'

import { SessionReply } from '@Utils/sessionReply'
import '@/components/Chart/echart-import'

const app = createApp(App)

//@ts-ignore
const isProd = process.env.NODE_ENV !== 'development'

if (isProd) {
  SessionReply.init({
    vueInstance: app,
    routerInstance: router,
    vueOptions: {
      logErrors: false
    }
  })
}

QuestionnaireSdk.init({
  appId: isProd ? 'g3LtMOItxNFErrjAh3Esb' : 'oL54mQjUTGdtPOn9nBnni',
  env: isProd ? 'prod' : 'uat',
  zIndex: 999
})

translate.init(source)

setCommonApp(app)
checkIsLogin(() => {
  app.mount('#app')
})
